import React from 'react';
import { Box, Text } from '@chakra-ui/react';

const Finanzas = () => {
  return (
    <Box>
      <Text fontWeight="semibold" textStyle="4xl">Finanzas</Text>
      <Text>Bienvenido a tus Finanzas</Text>
    </Box>
  );
};

export default Finanzas;
